export default __webpack_public_path__ + "static/media/osmiornica.446fd056.png";